export default "__VITE_ASSET__5856e718__"